import { useMutation } from "@tanstack/react-query";
import Cookies from "js-cookie";
import config from "./config";
import { ResponseError, ResponseErrorBody } from "./types/responseError";

interface CreateEntityPayload {
  companyName: string;
  countryCode: string;
  countryState?: string;
}

//TODO delete FF editableProfileEnabled after the feature is tested on prod
interface CreateEntityResponse {
  investorId: string;
  editableProfileEnabled: boolean;
}

export const useCreateEntityMutation = () =>
  useMutation<CreateEntityResponse, ResponseError, CreateEntityPayload>({
    mutationFn: async (payload) => {
      const response = await fetch(
        `${config.SID_GW_BASE_URL}/v1/investor/create-entity`,
        {
          credentials: "include",
          headers: {
            Authorization: Cookies.get("auth-token") ?? "",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok) {
        let body: ResponseErrorBody | undefined;
        try {
          body = (await response.json()) as ResponseErrorBody;
        } catch {
          throw new ResponseError("Error creating entity investor", response);
        }
        throw new ResponseError(
          "Error creating entity investor",
          response,
          body,
        );
      }

      return response.json() as Promise<CreateEntityResponse>;
    },
  });
